import React from 'react';
import ReportViewer from "./base/ReportViewer";

const AnalyseStatiquespeche = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"AnalyseStatiquespêche"}/>
        </div>
    );
}
export default AnalyseStatiquespeche;